import { Component, ElementRef, input, viewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Table, TableModule } from "primeng/table";
import { TagModule } from "primeng/tag";
import { InputTextModule } from "primeng/inputtext";
import { IconFieldModule } from "primeng/iconfield";
import { InputIconModule } from "primeng/inputicon";
import { getLogLevelSeverity, LogTagSeverity, ParsedLogEntry } from "../../utils/log-parsing-helper";

@Component({
  selector: "app-log-table",
  standalone: true,
  imports: [CommonModule, TableModule, TagModule, InputTextModule, IconFieldModule, InputIconModule],
  templateUrl: "./log-table.component.html",
  styleUrls: ["./log-table.component.scss"]
})
export class LogTableComponent {
  logs = input<ParsedLogEntry[]>([]);

  private readonly searchInput = viewChild<ElementRef<HTMLInputElement>>("searchInput");

  searchTerm = "";

  onSearchInput(value: string, table: Table): void {
    this.searchTerm = value;
    table.filterGlobal(value, "contains");
  }

  clearSearch(table: Table): void {
    this.searchTerm = "";
    table.filterGlobal("", "contains");
    this.searchInput()?.nativeElement.focus();
  }

  getLevelSeverity(level: string): LogTagSeverity {
    return getLogLevelSeverity(level);
  }
}
